export const PauseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M5.5 3.5C6.32843 3.5 7 4.17157 7 5V11C7 11.8284 6.32843 12.5 5.5 12.5C4.67157 12.5 4 11.8284 4 11V5C4 4.17157 4.67157 3.5 5.5 3.5Z"
      fill="#2C2543"
    />
    <path
      d="M10.5 3.5C11.3284 3.5 12 4.17157 12 5V11C12 11.8284 11.3284 12.5 10.5 12.5C9.67157 12.5 9 11.8284 9 11V5C9 4.17157 9.67157 3.5 10.5 3.5Z"
      fill="#2C2543"
    />
  </svg>
);
